export default "__VITE_ASSET__DZ2L0a3z__"